module.exports = __webpack_public_path__ + "img/sn-tw.10dce2bc.svg";